import { useLocation, useNavigate } from "react-router";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import { useEffect, useState } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

export default function VenueAreasTable(){
	const [venueAreas, setVenueAreas] =useState<any[]>([]);
	const navigate = useNavigate();

	const featchVenueAreas = async() => {
		const token = localStorage.getItem("token");
		const response = await fetch(`${apiUrl}/venue_area`, {
			headers: {
				"Content-Type": "application/json",
				"token": token || "",
			}
		});
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const result = await response.json();
		if (result.success) {
			setVenueAreas(result.venueAreas);
		} else {
			setVenueAreas([]);
		}
	}

	// Initial load
	useEffect(() => {
		featchVenueAreas();
	}, []);

	const handleRowClick = (area: any) => {
		navigate("/update-venue-area", { state: { area } });
	}

	return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-10 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Venue Area Name
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
					{venueAreas.map((venuearea) => (
            <TableRow key={venuearea.venuearea_id} className="cursor-pointer hover:bg-[#ffffa3]" onClick={() => handleRowClick(venuearea)}>
              <TableCell className="px-10 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
              <span>{venuearea.name}</span>
              </TableCell>
            </TableRow>
					))}
        </TableBody>
      </Table>  
    </>
	
	)
}